import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { DialogActions } from '@e3dc-react/shell/Elements/Dialog/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React, { useState } from 'react'
import { ShopPopupMessage } from '../models/shop-popup-message.model'
import { markShopPopupMessageAsRead } from '../utils/shop-popup-message-session'
import ShopPopupMessageModalContent from './ShopPopupMessageModalContent'

export interface ShopPopupMessageModalProps {
  messages: ShopPopupMessage[]
  onClose: () => void
  place: number
}

/*
 * Displays shop messages with the portal notification cards and pagination.
 */
const ShopPopupMessageModal: React.FC<ShopPopupMessageModalProps> = ({ messages, onClose, place }) => {
  const { t } = useCustomTranslation()
  const [unreadMessages, setUnreadMessages] = useState(messages)

  const closeAction: DialogActions = {
    secondary: [{ name: t('common.close'), onClick: onClose }],
  }

  const markMessageAsRead = (contentHash: string): void => {
    markShopPopupMessageAsRead(contentHash)
    if (unreadMessages.length === 1) {
      onClose()
      return
    }

    setUnreadMessages(currentMessages => currentMessages.filter(currentMessage => currentMessage.contentHash !== contentHash))
  }

  return (
    <Dialog title={t('notification.dialog.title')} place={place} onClose={onClose} actions={closeAction} maxWidth="md" scrollable={false}>
      {unreadMessages.length > 0 && (
        <ShopPopupMessageModalContent messages={unreadMessages} title={t('shop.common.hint')} onMarkMessageAsRead={markMessageAsRead} />
      )}
    </Dialog>
  )
}

export default ShopPopupMessageModal
